<template>
  <vs-sidebar click-not-close position-right parent="body"  default-index="1" color="primary" :hidden-background="true" class="add-new-data-sidebar items-no-padding cstm-add-data-sidebar" spacer v-model="isSidebarActiveLocal">

    <div class="mt-6 flex items-center justify-between px-6">
      <h4 class="heading-holder">{{ header }}</h4>
      <feather-icon icon="PlusIcon" @click="addActivitiesMeeting" class="cursor-pointer"></feather-icon>
      <feather-icon icon="XIcon" @click="closeActivitiesMeeting" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component  :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <!-- <perfect-scrollbar @ps-scroll-x="onScroll" ref="scrollbar"> -->
      <!-- <section @scroll="handleScroll"> -->
      <div class="p-6">
        <vs-row>
          <vs-card v-for="singleActivitiesMeeting in activitiesMeetingListData" :key="singleActivitiesMeeting.activities_meeting_id">
            <vs-row>
              <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1"><calendar-icon size="1.5x" class="custom-class"></calendar-icon></vs-col>
              <vs-col vs-type="flex"  vs-justify="left" vs-align="center" vs-w="9"><h4>{{ singleActivitiesMeeting.appointment_title }}</h4></vs-col>
              <vs-col  vs-type="flex" vs-justify="right" vs-align ="center" vs-w="1">
                <vs-button radius color="primary" icon="edit" @click="fetchActivitiesMeetingForEdit(singleActivitiesMeeting.activities_meeting_id)" class="mr-1"></vs-button> 
              </vs-col>
              <vs-col vs-type="flex" vs-justify="right"   vs-align="center" vs-w="1"> 
                <vs-button radius color="danger" @click="activitiesMeetingDelete(singleActivitiesMeeting.activities_meeting_id)" icon="delete" >
                </vs-button> 
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="1"></vs-col>
              <vs-col vs-type="flex"  vs-justify="left" vs-align="center" vs-w="9">{{ singleActivitiesMeeting.appointment_description }}</vs-col>
            </vs-row>
            <small style="float:right">{{ singleActivitiesMeeting.created_at }}</small>
          </vs-card>
          <infinite-loading @infinite="infiniteHandler" spinner="circles"></infinite-loading>
        </vs-row>           
      </div>
    </component>
    <!-- </perfect-scrollbar> -->
  </vs-sidebar>
  

</template>

<script>
import { activitiesMeetingList, deleteActivitesMeeting } from '@/api/activitiesmeeting'

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { CalendarIcon } from 'vue-feather-icons'


export default {

  components: {
    VuePerfectScrollbar,
    vSelect,
    flatPickr,
    CalendarIcon
  },

  data () {
    return {
      addActivitiesMeetingFrom : false,
      header: 'Appointments',
      editActivitesMeetingId : '',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 10,
        wheelSpeed: .60
      },
      isSidebarActiveLocal : true
    }
  },
  props : {
    leadId: {
      type: Number,
      required: true
    }, 
    activitiesMeetingListData : {
      type: Array,
      default: () => []
    },
    activitiesMeetingMetaData : {
      type: Object,
      default: () => {}
    }
  },

  mounted ()  {
    this.listActivitiesMeetings()
    
  },

  methods: {
    submitData () {
      
    },

    listActivitiesMeetings () {
      
    },
    onScroll (event) {
      
    },

    infiniteHandler ($state) {
      if (this.activitiesMeetingMetaData.has_next) {
        activitiesMeetingList(10, this.activitiesMeetingMetaData, 'CRM', this.leadId, this.$store.getters.customerId).then(apiResponse => {
          this.activitiesMeetingListData.push(...apiResponse.data.data.activities_meetings_list)
          this.activitiesMeetingMetaData = apiResponse.data.data.meta
          if (!this.activitiesMeetingMetaData.has_next) {
            $state.complete()
            // $state.error()
          } else {
            $state.reset()
          }
        })
      } else  {
        $state.complete()
      }
    },
    activitiesMeetingDelete (activitiesMeetingId) {
      deleteActivitesMeeting(activitiesMeetingId).then(response => {
        const deletedActivitiesMeeting = this.activitiesMeetingListData.findIndex(item => item.activities_meeting_id === activitiesMeetingId)
        this.activitiesMeetingListData.splice(deletedActivitiesMeeting, 1)
        this.$vs.notify({
          title: 'Success',
          text: response.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      }).catch(apiError => {
        
      })
    },
    fetchActivitiesMeetingForEdit (activitiesMeetingId) {
      this.editActivitesMeetingId = activitiesMeetingId
      this.$emit('closeListActivitiesMeeting', 'openAddActivitiesMeetingForEdit', this.editActivitesMeetingId)
    },

    addActivitiesMeeting () {
      // this.$destroy();
      this.$emit('closeListActivitiesMeeting', 'openAddActivitiesMeeting', this.editActivitesMeetingId)
    },
    closeActivitiesMeeting () {
      // this.$destroy();
      this.$emit('closeListActivitiesMeeting', 'closeActivitiesMeeting')
    }

  },

  computed: {
    scrollbarTag () { 
      return this.$store.getters.scrollbarTag 
    }
  }
}
</script>

<style lang="scss" scoped>
.vs-component .vs-dropdown--item, .vs-dropdown--item-link, .vs-dropdown--group-label, .vs-component .vs-dropdown--group .marginIcon {
    font-weight: 500 !important;
  }
  .vs-sidebar-position-right {
    width: 800px !important;
    max-width: 800px !important;
    z-index: 111111111111111 !important;
    /*height: auto !important;*/
    /*position: absolute;*/
    /*top: 12%;*/
  }
  // [dir] .vs-content-sidebar.items-no-padding .vs-sidebar--items{
  //   overflow-y: scroll;
  // }
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 600px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
